import { TRAITS } from 'components/common/ScoreCard/ScoreCard'
import { formatTraitAbstract, getRecruiterTraits } from './helpScoreCardText'

const CARD_THEMES = { H1: 'blue', H2: 'teal', H3: 'slate' }

const QUOTES = {
  H1: {
    en: 'I enjoy the challenge when I have to do more than one thing at a time',
    nb: 'Jeg trives med utfordringen når jeg må gjøre mer enn en ting om gangen',
  },
  H2: {
    en: 'Most of my life is spent doing things that are meaningful',
    nb: 'Mesteparten av mitt liv blir brukt til å gjøre ting som er meningsfulle',
  },
  H3: {
    en: 'It is up to me to decide how the rest of my life will be',
    nb: 'Det er opp til meg å avgjøre hvordan resten av mitt liv skal bli',
  },
}

const buildHardinessCard = (traitId, index, language) => {
  const traits = getRecruiterTraits(language)
  const { label = traitId, abstract } = traits[traitId] || {}

  return {
    id: traitId,
    number: String(index + 1).padStart(2, '0'),
    title: label,
    theme: CARD_THEMES[traitId],
    description: formatTraitAbstract(abstract, label),
    quote: QUOTES[traitId]?.[language] ?? QUOTES[traitId]?.en ?? '',
  }
}

export const getHardinessCards = language =>
  (TRAITS.Hardiness || []).map((traitId, index) =>
    buildHardinessCard(traitId, index, language),
  )

export const HARDINESS_SECTION_TITLE = {
  en: 'What is hardiness, negative and positive affectivity?',
  nb: 'Hva er hardførhet, negativ og positiv affektivitet?',
}

export const HARDINESS_BODY_SPLIT = {
  en: 'Positive and negative affectivity',
  nb: 'Positiv og negativ affektivitet',
}
